module.exports = "<div class=\"preloader-wrapper active  {{spinnerType}}\">\n    <nx-spinners nxSpinners mode=\"indeterminate\"></nx-spinners>\n</div>"